module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-index",
    class: {
      'hidden-scroll': _vm.menuState
    },
    style: ({
      'backgroundImage': 'url(' + _vm.bg + ')'
    }),
    attrs: {
      "id": "index"
    },
    on: {
      "scroll": _vm.changeMenuClass
    }
  }, [_c('div', {
    ref: "content",
    staticClass: "page-index-content"
  }, [_c('preview-app', {
    attrs: {
      "matches": _vm.matches
    },
    on: {
      "changedStatistic": _vm.getStatistic
    }
  }), _vm._v(" "), (_vm.statistic) ? _c('div', {
    staticClass: "wrapper"
  }, [(_vm.$root.isMobile) ? _c('div', {
    staticClass: "mobile-show"
  }, [_c('smallView', {
    staticClass: "first",
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_3_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_3_1_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_3_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_3_2_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])
      },
      "textHome": _vm.statistic.b_right_3_1_text,
      "textAway": _vm.statistic.b_right_3_2_text,
      "icon": 'pass'
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "swift",
    class: _vm.banners[_vm.statistic.banner_right_1].className,
    attrs: {
      "to": _vm.banners[_vm.statistic.banner_right_1].link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvent('main', 'click', _vm.banners[_vm.statistic.banner_left_1].className)
      }
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      backgroundImage: 'url(' + _vm.banners[_vm.statistic.banner_right_1].img + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-body"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_1].name))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.banners[_vm.statistic.banner_right_1].title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "descr"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_1].desc))])]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v("Узнать больше")])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "leftside"
  }, [_c('bigView', {
    attrs: {
      "countryName": _vm.currentMatch.fkParticipants1.name,
      "countryFlag": _vm.currentMatch.fkParticipants1.image,
      "icon": 'move',
      "titleNumber": _vm.statistic.b_left_1_count,
      "titleText": _vm.$root.Helpers.declension(_vm.statistic.b_left_1_count, ['передачу', 'передачи', 'передач']),
      "contentText": _vm.statistic.b_left_1_text
    }
  }), _vm._v(" "), _c('bigView', {
    attrs: {
      "countryName": _vm.currentMatch.fkParticipants2.name,
      "countryFlag": _vm.currentMatch.fkParticipants2.image,
      "icon": 'move',
      "titleNumber": _vm.statistic.b_left_2_count,
      "titleText": _vm.$root.Helpers.declension(_vm.statistic.b_left_2_count, ['передачу', 'передачи', 'передач']),
      "contentText": _vm.statistic.b_left_2_text
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rightside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_1_1_count + '%',
        hasBr: true,
        text: 'единоборств'
      },
      "titleAway": {
        number: _vm.statistic.b_right_1_2_count + '%',
        hasBr: true,
        text: 'выигранных единоборств'
      },
      "textHome": _vm.statistic.b_right_1_1_text,
      "textAway": _vm.statistic.b_right_1_2_text
    }
  }), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_2_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_2_1_count, ['передачу', 'передачи', 'передач'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_2_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_2_2_count, ['передачу', 'передачи', 'передач'])
      },
      "textHome": _vm.statistic.b_right_2_1_text,
      "textAway": _vm.statistic.b_right_2_2_text,
      "icon": 'exchange'
    }
  }), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "mobile-hidden"
  }, [_c('router-link', {
    staticClass: "swift",
    class: _vm.banners[_vm.statistic.banner_right_1].className,
    attrs: {
      "to": _vm.banners[_vm.statistic.banner_right_1].link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvent('main', 'click', _vm.banners[_vm.statistic.banner_left_1].className)
      }
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      backgroundImage: 'url(' + _vm.banners[_vm.statistic.banner_right_1].img + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-body"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_1].name))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.banners[_vm.statistic.banner_right_1].title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "descr"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_1].desc))])]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v("Узнать больше")])])])]), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_3_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_3_1_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_3_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_3_2_count, ['удачную обводку', 'удачные обводки', 'удачных обводок'])
      },
      "textHome": _vm.statistic.b_right_3_1_text,
      "textAway": _vm.statistic.b_right_3_2_text,
      "icon": 'pass'
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "leftside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_left_3_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_left_3_1_count, ['удар', 'удара', 'ударов'])
      },
      "titleAway": {
        number: _vm.statistic.b_left_3_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_left_3_2_count, ['удар', 'удара', 'ударов'])
      },
      "textHome": _vm.statistic.b_left_3_1_text,
      "textAway": _vm.statistic.b_left_3_2_text,
      "icon": 'ball'
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "swift swift--small",
    class: _vm.banners[_vm.statistic.banner_left_1].className,
    attrs: {
      "to": _vm.banners[_vm.statistic.banner_left_1].link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvent('main', 'click', _vm.banners[_vm.statistic.banner_left_1].className)
      }
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      backgroundImage: 'url(' + _vm.banners[_vm.statistic.banner_left_1].img + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-body"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_left_1].name))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.banners[_vm.statistic.banner_left_1].title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "descr"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_left_1].desc))])]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v("Узнать больше")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "rightside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_4_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_4_1_count, ['удар', 'удара', 'ударов'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_4_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_4_2_count, ['удар', 'удара', 'ударов'])
      },
      "textHome": _vm.statistic.b_right_4_1_text,
      "textAway": _vm.statistic.b_right_4_2_text,
      "icon": 'kickGreen'
    }
  }), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_5_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_5_1_count, ['острую передачу', 'острых передачи', 'острых передач'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_5_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_5_2_count, ['острую передачу', 'острых передачи', 'острых передач'])
      },
      "textHome": _vm.statistic.b_right_5_1_text,
      "textAway": _vm.statistic.b_right_5_2_text,
      "backgroundImg": 'url(/static/img/pages/main/block_img_2.png)'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "leftside"
  }, [_c('bigView', {
    attrs: {
      "countryName": _vm.currentMatch.fkParticipants1.name,
      "countryFlag": _vm.currentMatch.fkParticipants1.image,
      "icon": 'move',
      "titleNumber": _vm.statistic.b_left_4_count,
      "titleText": _vm.$root.Helpers.declension(_vm.statistic.b_left_4_count, ['ключевую передачу', 'ключевые передачи', 'ключевых передач']),
      "contentText": _vm.statistic.b_left_4_text,
      "backgroundImg": 'url(/static/img/pages/main/block_img_1.png)'
    }
  }), _vm._v(" "), _c('bigView', {
    attrs: {
      "countryName": _vm.currentMatch.fkParticipants2.name,
      "countryFlag": _vm.currentMatch.fkParticipants2.image,
      "icon": 'move',
      "titleNumber": _vm.statistic.b_left_5_count,
      "titleText": _vm.$root.Helpers.declension(_vm.statistic.b_left_5_count, ['ключевую передачу', 'ключевые передачи', 'ключевых передач']),
      "contentText": _vm.statistic.b_left_5_text,
      "backgroundImg": 'url(/static/img/pages/main/block_img_1.png)'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rightside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_6_1_count + '%',
        hasBr: false,
        text: 'точных передач'
      },
      "titleAway": {
        number: _vm.statistic.b_right_6_2_count + '%',
        hasBr: false,
        text: 'точных передач'
      },
      "textHome": _vm.statistic.b_right_6_1_text,
      "textAway": _vm.statistic.b_right_6_2_text
    }
  }), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_7_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_7_1_count, ['точную передачу', 'точные передачи', 'точных передач'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_7_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_7_2_count, ['точную передачу', 'точные передачи', 'точных передач'])
      },
      "textHome": _vm.statistic.b_right_7_1_text,
      "textAway": _vm.statistic.b_right_7_2_text,
      "icon": 'kickRose'
    }
  }), _vm._v(" "), _c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_8_1_count + '%',
        hasBr: true,
        text: 'удачных отборов'
      },
      "titleAway": {
        number: _vm.statistic.b_right_8_2_count + '%',
        hasBr: true,
        text: 'удачных отборов'
      },
      "textHome": _vm.statistic.b_right_8_1_text,
      "textAway": _vm.statistic.b_right_8_2_text
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "swift",
    class: _vm.banners[_vm.statistic.banner_right_2].className,
    attrs: {
      "to": _vm.banners[_vm.statistic.banner_right_2].link
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvent('main', 'click', _vm.banners[_vm.statistic.banner_left_1].className)
      }
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      backgroundImage: 'url(' + _vm.banners[_vm.statistic.banner_right_2].img + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-body"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_2].name))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.banners[_vm.statistic.banner_right_2].title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "descr"
  }, [_c('span', [_vm._v(_vm._s(_vm.banners[_vm.statistic.banner_right_2].desc))])]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v("Узнать больше")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "leftside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_left_6_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_left_6_1_count, ['потерю', 'потери', 'потерь'])
      },
      "titleAway": {
        number: _vm.statistic.b_left_6_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_left_6_2_count, ['потерю', 'потери', 'потерь'])
      },
      "textHome": _vm.statistic.b_left_6_1_text,
      "textAway": _vm.statistic.b_left_6_2_text,
      "icon": 'kickRose'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rightside"
  }, [_c('smallView', {
    attrs: {
      "countryHome": _vm.currentMatch.fkParticipants1.image,
      "countryAway": _vm.currentMatch.fkParticipants2.image,
      "titleHome": {
        number: _vm.statistic.b_right_9_1_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_9_1_count, ['удачную обводку', 'удачных обводки', 'удачных обводок'])
      },
      "titleAway": {
        number: _vm.statistic.b_right_9_2_count,
        hasBr: false,
        text: _vm.$root.Helpers.declension(_vm.statistic.b_right_9_2_count, ['удачную обводку', 'удачных обводки', 'удачных обводок'])
      },
      "textHome": _vm.statistic.b_right_9_1_text,
      "textAway": _vm.statistic.b_right_9_2_text,
      "icon": 'tackle'
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e853781","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Index.vue
// module id = 643
// module chunks = 1